<script lang="ts">
    import { service } from "@frontend/services";
    import type { AddGameServerDTO, ApiResultOfGameServerDTO, AuthenticatedRequestOfAddGameServerDTO } from "@frontend/walletapi";
    import { translate, currentLanguage } from "../Translator";
    
    export let dismiss: () => void;
    
    let newServer = {
        Label: '',
        User: '',
        Password: '',
        Endpoint: ''
    };

    let result: ApiResultOfGameServerDTO | undefined = undefined;
    let isSubmitting = false;

    async function AddServer() {
        if (isSubmitting) return;
        
        isSubmitting = true;
        const addServerDTO: AddGameServerDTO = {
            Label: newServer.Label,
            User: newServer.User,
            Password: newServer.Password,
            Endpoint: newServer.Endpoint
        };

        const addServerRequest: AuthenticatedRequestOfAddGameServerDTO = {
            Token: sessionStorage.token,
            Data: addServerDTO
        };

        try {
            result = await service.walletapi.addGameServer(addServerRequest);
            
            if (result.Success) {
                console.log("Server added successfully:", result.Data);
                dismiss();
            } else {
                console.error("Error adding server:", result.ErrorMessage);
            }
        } catch (error) {
            console.error("Error adding server:", error);
            result = {
                Success: false,
                ErrorMessage: error instanceof Error ? error.message : "An unexpected error occurred"
            };
        } finally {
            isSubmitting = false;
        }
    }
</script>

<h2 class="ui centered dividing header">{$translate('Add Game Server')}</h2>

{#if result && !result.Success}
    <div class="ui negative message">
        <div class="header">Error</div>
        <p>{result.ErrorMessage ?? "Unknown error when adding server"}</p>
    </div>
{/if}

<form class="ui form" on:submit|preventDefault={AddServer}>
    <div class="field">
        <label for="">{$translate('Label')}</label>
        <input 
            type="text"
            bind:value={newServer.Label}
            placeholder="Enter server label"
            required
            disabled={isSubmitting}
        >
    </div>

    <div class="field">
        <label for="">{$translate('Username')}</label>
        <input 
            type="text"
            bind:value={newServer.User}
            placeholder="Enter username"
            required
            disabled={isSubmitting}
        >
    </div>

    <div class="field">
        <label for="">{$translate('Password')}</label>
        <input 
            type="text"
            bind:value={newServer.Password}
            placeholder="Enter password"
            required
            disabled={isSubmitting}
        >
    </div>

    <div class="field">
        <label for="">{$translate('Endpoint')}</label>
        <input 
            type="text"
            bind:value={newServer.Endpoint}
            placeholder="Enter server endpoint (IP or URL)"
            required
            disabled={isSubmitting}
        >
    </div>

    <div class="two fields" style="display: flex">
        <button class="ui negative fluid button" type="button" on:click={dismiss} disabled={isSubmitting}>{$translate('Cancel')}</button>
        <button class="ui positive fluid button" type="submit" disabled={isSubmitting}>
            {#if isSubmitting}
                <i class="spinner loading icon"></i>
                {$translate('Adding...')}
            {:else}
                {$translate('Add Server')}
            {/if}
        </button>
    </div>
</form>
